import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['linkToModal']

  connect(){
    if (this.linkToModalTarget.dataset.settingsChanged == 'true') {
      // Had to do a trick here. In order to prevent users from triggering this request again when using "go back" in the browser we provide an initial time when this was called.
      // We then compare that against current time.
      // Current time in seconds
      const currentTime = Math.floor(Date.now() / 1000);
      const initialTime = this.linkToModalTarget.dataset.initialTimeValue;

      if (Math.abs(currentTime - initialTime) <= 2) {
        this.linkToModalTarget.click();
      }
    }
  }
}
